document.addEventListener('DOMContentLoaded', function() {
    const radioButtons = document.querySelectorAll('input[name="billing_user_role"]');
    const nameWrapper = document.querySelector('.register-page .name_wrapper');
    const surnameWrapper = document.querySelector('.register-page .surname_wrapper');
    const pivaWrapper = document.querySelector('.register-page .piva_wrapper');
    const companyWrapper = document.querySelector('.register-page .company_wrapper');
    const taxIdWrapper = document.querySelector('.register-page .tax_id_wrapper');

    const passwordInput = document.querySelector('.register-page input#reg_password');
    const repeatPassword = document.querySelector('.register-page input#reg_repet_password');
    const submitBtn = document.querySelector('.register-page button.btn.btn-secondary.w-100');

    pivaWrapper.required = false;
    companyWrapper.required = false;
    taxIdWrapper.required = false;

    radioButtons.forEach(function(radio) {
        radio.addEventListener('change', function(event) {
            // Logica custom in base al valore selezionato
            const selectedValue = event.target.value;

            switch (selectedValue) {
                case 'customer':
                    pivaWrapper.classList.add('d-none')
                    companyWrapper.classList.add('d-none')
                    taxIdWrapper.classList.add('d-none')

                    pivaWrapper.querySelector('input').required=false;
                    companyWrapper.querySelector('input').required=false;
                    taxIdWrapper.querySelector('input').required=false;

                    nameWrapper.classList.remove('d-none')
                    surnameWrapper.classList.remove('d-none')

                    nameWrapper.querySelector('input').required=true;
                    surnameWrapper.querySelector('input').required=true;

                    break;
                case 'associazione':
                    pivaWrapper.classList.add('d-none')
                    nameWrapper.classList.add('d-none')
                    surnameWrapper.classList.add('d-none')

                    pivaWrapper.querySelector('input').required=false;
                    nameWrapper.querySelector('input').required=false;
                    surnameWrapper.querySelector('input').required=false;

                    companyWrapper.classList.remove('d-none')
                    taxIdWrapper.classList.remove('d-none')

                    companyWrapper.querySelector('input').required=true;
                    taxIdWrapper.querySelector('input').required=true;

                    break;
                case 'azienda':
                    nameWrapper.classList.add('d-none')
                    surnameWrapper.classList.add('d-none')
                    taxIdWrapper.classList.add('d-none')

                    nameWrapper.querySelector('input').required=false;
                    surnameWrapper.querySelector('input').required=false;
                    taxIdWrapper.querySelector('input').required=false;

                    companyWrapper.classList.remove('d-none')
                    pivaWrapper.classList.remove('d-none')

                    companyWrapper.querySelector('input').required=true;
                    pivaWrapper.querySelector('input').required=true;

                    break;

            }
        });
    });

    if(submitBtn){
        submitBtn.addEventListener('click', e =>{
            passwordInput.style.border = '1px solid #CED4DA'
            repeatPassword.style.border = '1px solid #CED4DA'
           if (passwordInput.value !== repeatPassword.value){
               e.preventDefault();
               console.log('error')
               managePswError(e)
           }else{
               let pswErrorParagraph = document.querySelector('.register-page p.psw-error')
               if(pswErrorParagraph){
                   pswErrorParagraph.remove();
               }
           }
        });
    }

    function managePswError(e){
        let currentError = document.querySelector('.register-page p.psw-error');
        if(!currentError || currentError.length <= 0){
            let error = document.createElement('p')
            error.classList.add('text-danger', 'psw-error', 'text-center', 'pt-2')
            error.innerHTML = 'Le password devono essere uguali'
            passwordInput.style.border = '1px solid red'
            repeatPassword.style.border = '1px solid red'
            e.target.parentElement.appendChild(error)
        }

        if(currentError || currentError.length <= 0){
            passwordInput.style.border = '1px solid red'
            repeatPassword.style.border = '1px solid red'
        }
    }

});